<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Update Invite Template</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Building ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Corporations</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <angular2-multiselect name="corporations"
                                                  required
                                                  [data]="es.corporations"
                                                  [(ngModel)]="selectedCorporations"
                                                  [settings]="{
                                                      singleSelection: false,
                                                      text: 'Select Corporations',
                                                      selectAllText: 'Select All',
                                                      unSelectAllText: 'Deselect All',
                                                      enableSearchFilter: true,
                                                      classes: 'with-filter'
                                                  }">
                            </angular2-multiselect>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>

                    <spinner [spinnerShow]="es.loadingCorporations"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/email/choose-corporation-modal/choose-corporation-modal.component.html